import { render, staticRenderFns } from "./files-comments.vue?vue&type=template&id=2429bf02"
import script from "./files-comments.vue?vue&type=script&lang=js"
export * from "./files-comments.vue?vue&type=script&lang=js"
import style0 from "./files-comments.vue?vue&type=style&index=0&id=2429bf02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports